import React from 'react';
import BillingPolicyBuilder from '../../BillingPolicyBuilder/BillingPolicyBuilder';
import clsx from "clsx";

export default class RatePresenterBillingPolicy extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == 'billing_policy',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="billing_policy">
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading">
                <h3 className="panel-title pull-left">
                {`${I18n.t('billing_policy')}*`} <span className="ss-help help" title={I18n.t('billing_policy_helper_text')}></span>
                </h3>
                <div className="clearfix"></div>
              </div>
              <div className="panel-body">
                { this.renderBillingPolicy() }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderBillingPolicy() {
    if (this.props.billing_policy) {
      return (
        <div style={{marginBottom: -30}}>
          <BillingPolicyBuilder 
            onChange={this.onChange} 
            {...this.props.billing_policy} 
            nested={true} 
            read_only={true} 
            hideModalButtons={true} />
        </div>
      )
    } else {
      return (
        <div className="no-records">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
  }

}
